// Custom Capacitor plugin bridging the Android Play Integrity API.
// Native implementation lives in
// android/app/src/main/java/com/yourname/pantry/PlayIntegrityPlugin.java
import { registerPlugin } from "@capacitor/core";

export interface PlayIntegrityPlugin {
  // Requests a Play Integrity token bound to a server-issued nonce (see the
  // `request-integrity-nonce` edge function). Android only — do not call on
  // iOS or web.
  requestIntegrityToken(options: { nonce: string }): Promise<{ token: string }>;
}

export const PlayIntegrity =
  registerPlugin<PlayIntegrityPlugin>("PlayIntegrity");
